import ChatUserAvatar from './ChatUserAvatar';

export default ChatUserAvatar;
